import dayjs, { Dayjs, ManipulateType } from "dayjs";

export const getDaysInRange = (
  startDate: string,
  endDate: string,
  dailyOrWeekly: string,
): string[] => {
  const start: Dayjs = dayjs(startDate);
  const end: Dayjs = dayjs(endDate);
  const days: string[] = [];
  let addNumber: number = 1;
  let addition: ManipulateType = "day";

  switch (dailyOrWeekly) {
    case "daily":
      addition = "day";
      break;
    case "Weekly":
      addition = "week";
      break;
    case "Fortnightly":
      addNumber = 2;
      addition = "week";
      break;
    case "monthly":
      addition = "month";
      break;
    case "yearly":
      addition = "year";
      break;
  }

  let current: Dayjs = start;

  while (current.isBefore(end) || current.isSame(end, "day")) {
    days.push(current.format("YYYY-MM-DD"));
    current = current.add(addNumber, addition);
  }

  return days;
};
